import { render, staticRenderFns } from "./transfer-enterprise.vue?vue&type=template&id=d5841be8"
import script from "./transfer-enterprise.vue?vue&type=script&lang=js"
export * from "./transfer-enterprise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports